<div class="flex">
  <sbnb-subnav [header]="'SETTINGS.SETTINGS' | transloco">
    <sbnb-settings-subnav></sbnb-settings-subnav>
  </sbnb-subnav>

  <main class="subnav__exists flex flex-1 flex-col" [ngClass.lt-md]="{ mobile: true, subnav__exists: false }">
    <sbnb-helptext-wrapper [area]="'intro'" [pageId]="'active-listings'"></sbnb-helptext-wrapper>

    <sbnb-loading-spinner *ngIf="loading" [minHeight]="'200px'"></sbnb-loading-spinner>

    <div *ngIf="!loading && billingCycles?.length > 0" class="flex flex-col">
      <div class="flex flex-wrap justify-between gap-4">
        <app-feature-flag-tabs class="w-full sbnbDesktop:w-auto">
          <sbnb-page-header navTabs class="w-full sbnbDesktop:w-auto">
            <h2 class="nomargin">Active Properties</h2>
          </sbnb-page-header>
          <h2 class="nomargin">Active Properties</h2>
        </app-feature-flag-tabs>
        <!-- date switcher-->
        <mat-form-field
          class="input__mini invoice-selector md:w-[340px]"
          *ngIf="currentCycleData$ | async as currentCycle"
          [ngClass.lt-md]="'fw'">
          <!-- Billing period switcher -->
          <mat-select
            [(ngModel)]="currentCycle.cycle"
            (ngModelChange)="cycleChanged($event)"
            placeholder="Select a billing period">
            <mat-option *ngFor="let cycle of billingCycles" [value]="cycle">
              {{ cycle.label }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <div class="flex flex-col gap-9" *ngIf="currentCycleData$ | async as currentCycle">
        <div *ngIf="currentCycle.cycle.label === 'Future invoice estimate'" class="text__small">
          Active properties under your account are updated hourly. Changes in the number of active properties may not
          reflect immediately.
        </div>

        <div *ngIf="currentCycle">
          <!-- Overview box container-->
          <div class="flex flex-col lg:flex-row gap-2 lg:gap-7">
            <sbnb-overview-box
              class="flex-1"
              [title]="totals.active | number"
              subtitle="Active Properties"
              [title2]="totals.free | number"
              subtitle2="Free Properties"
              body="An “active” property has received at least one check-in within the billing cycle. This is regardless of the
              property being listed or not."
              tooltipText="Find out more..."
              [tooltipLink]="pricingBillingFaqLink"></sbnb-overview-box>

            <sbnb-overview-box
              *ngIf="currentCycle.cycleSummary"
              class="flex-1"
              [title]="currentCycle.cycleSummary.total_amount"
              [subtitle]="currentCycle.cycleSummary.is_current ? 'Estimated charge amount' : 'Amount charged'"
              [body]="
                !currentCycle.cycleSummary.charge_date
                  ? 'If you were to subscribe now, you will be charged this amount based on your activity as of <strong>' +
                    (currentCycle.cycleSummary.last_updated | timeAgo) +
                    '</strong>.'
                  : currentCycle.cycleSummary.is_current
                    ? 'The next renewal date is on <strong>' +
                      currentCycle.cycleSummary.charge_date +
                      '</strong>. This is an estimate based on your activity as of <strong>' +
                      (currentCycle.cycleSummary.last_updated | timeAgo) +
                      '</strong>.'
                    : 'You were charged on <strong>' +
                      currentCycle.cycleSummary.charge_date +
                      '</strong>. Your subscription is charged in <strong>' +
                      currentCycle.cycleSummary.currency +
                      '</strong>.'
              "
              tooltipText="Find out more..."
              [tooltipLink]="pricingBillingFaqLink"></sbnb-overview-box>
            <sbnb-overview-box
              class="flex-1"
              *ngIf="currentCycle.cycleSummary"
              [title]="currentCycle.cycleSummary.average_rate_per_listing"
              subtitle="Average rate per listing"
              body="This is the amount you are being charged per listing connected."
              tooltipText="Find out more..."
              [tooltipLink]="pricingBillingFaqLink"></sbnb-overview-box>
          </div>
        </div>

        <div class="flex flex-col gap-3">
          <h4>Properties in billing period</h4>

          <mat-divider></mat-divider>
          <!-- Filters and Search bar -->
          <div class="flex items-center justify-between">
            <sbnb-filter
              #filterComponent
              componentName="active-listings"
              [customEndpoint]="'/billing/active-properties/' + currentCycle.cycle.key + '/filters'"
              [hideSaveSegment]="true"
              [defaultFilters]="currentFilters"
              (filterChanged)="filtersUpdated($event)"
              (reset)="clearFilters()"></sbnb-filter>

            <sbnb-search-bar
              style="height: 32px"
              [initialVal]="searchCriteria"
              placeholderText="Property name"
              (searchChanged)="searchUpdated($event)"></sbnb-search-bar>
          </div>

          <sbnb-loading-spinner *ngIf="loadingProperties"></sbnb-loading-spinner>

          <!-- Table of properties -->
          <div class="rules__container" *ngIf="!loadingProperties">
            <!-- Table headings-->
            <div *ngIf="!loadingProperties && properties?.length > 0" class="flex rules__rule-header gap-5">
              <div class="flex flex-1" style="max-width: 60%">Property name</div>
              <div class="flex flex-1" style="max-width: 20%">Status</div>
              <div class="flex flex-1" style="max-width: 20%">Check-in activity</div>
            </div>

            <!-- No properties -->
            <sbnb-no-items
              *ngIf="!loadingProperties && properties?.length === 0"
              text="You don't have any properties yet."
              subtext="You don't appear to have any properties connected to your account at the moment."></sbnb-no-items>

            <!-- Table contents-->
            <a
              *ngFor="let property of properties"
              class="rules__rule-container flex gap-5"
              [class.bg-smoke-lighter]="property.muted"
              (click)="openListingDialog(property)">
              <!-- Property image and name-->
              <div class="flex flex-1 items-center rule__title gap-4" style="max-width: 60%">
                <img *ngIf="property.thumbnail" [src]="property.thumbnail" class="listing-img" [alt]="property.name" />
                <div *ngIf="!property.thumbnail" class="property-skeleton"></div>

                <span class="ellipsis" [class.strikethrough]="property.muted">{{ property.name }}</span>
              </div>

              <!-- Free / Active -->
              <div class="text__small flex items-center flex-1" style="max-width: 20%">
                {{ property.status | titlecase }}
              </div>

              <!-- Checkins for this listing-->
              <div class="text__small flex items-center flex-1" style="max-width: 20%">
                <span *ngIf="!property.guest_list?.length; else guestList">None</span>

                <ng-template #guestList>
                  <sbnb-checkin-activity-list [guests]="property.guest_list"></sbnb-checkin-activity-list>
                </ng-template>
              </div>
            </a>
          </div>

          <!-- Pagination controls -->
          <sbnb-pagination
            *ngIf="paginationData && properties?.length > 0 && paginationData.total > paginationData.per_page"
            position="end"
            [pageCount]="paginationData.last_page"
            [currentPage]="paginationData.current_page"
            (pageChanged)="handlePageChanged($event)"></sbnb-pagination>
        </div>
      </div>
    </div>
  </main>
</div>

<sbnb-mobile-sidebar [navTabsHide]="true" [title]="'Settings'">
  <sbnb-settings-subnav></sbnb-settings-subnav>
</sbnb-mobile-sidebar>
